module.exports = __webpack_public_path__ + "media/icons/movie94-ba507589.png";